import { StrictMode } from 'react';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { MotionController } from './components/MotionController';

export const SiteRoot = ({ path }: { path: string }) => (
  <StrictMode>
    <Toaster position="top-right" />
    <MotionController path={path} />
    <App path={path} />
  </StrictMode>
);
